"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/styles");
var styleObjs_1 = require("../../../../styles/styleObjs");
var ResultListItem_1 = __importDefault(require("./ResultListItem"));
var useStyles = styles_1.makeStyles(__assign({ listPart: {
        minWidth: 300,
        maxHeight: 300,
        overflowY: 'scroll',
    } }, styleObjs_1.clickBG));
function ResultList(props) {
    var listRefList = props.listRefList, selectedIndex = props.selectedIndex, onSelectValueResult = props.onSelectValueResult, closeResultListFn = props.closeResultListFn, valueResultList = props.valueResultList;
    var classes = useStyles();
    return (react_1.default.createElement(core_1.Box, null,
        react_1.default.createElement(core_1.Box, { id: 'clickBG', className: classes.clickBG, onClick: closeResultListFn }),
        react_1.default.createElement(core_1.Paper, { className: classes.listPart },
            react_1.default.createElement("ul", { style: { padding: 0, margin: 0, } }, valueResultList.map(function (res, i) {
                return (react_1.default.createElement(ResultListItem_1.default, __assign({ key: i, listItemRef: listRefList.current[i] }, res, { isSelected: selectedIndex === i, selectResultByClickFn: function () { return onSelectValueResult(res); } })));
            })))));
}
;
exports.default = ResultList;
